// UseTermsModal.jsx
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { Editor } from 'react-draft-wysiwyg';
import { UserContractData } from '../../../../../services/dataService';
import { toast } from 'react-toastify';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export default function UseTermsModal({ id_company, open, onClose }) {
  const [loading, setLoading] = useState(true);
  const [useterm, setUseTerm] = useState(() => EditorState.createEmpty());

  useEffect(() => {
    let mounted = true;
    async function fetchTerms() {
      setLoading(true);
      try {
        const res = await UserContractData.getUserTerms(id_company);
        const html = res?.data?.contract?.use_term || '';
        if (!mounted) return;

        if (html) {
          const blocksFromHtml = htmlToDraft(html);
          if (blocksFromHtml) {
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(
              contentBlocks,
              entityMap
            );
            setUseTerm(EditorState.createWithContent(contentState));
          } else {
            setUseTerm(EditorState.createEmpty());
          }
        } else {
          setUseTerm(EditorState.createEmpty());
        }
      } catch (err) {
        console.error('Erro fetchTerms:', err);
        toast.error('Erro ao carregar termos de uso');
      } finally {
        if (mounted) setLoading(false);
      }
    }

    if (id_company) fetchTerms();
    return () => { mounted = false; };
  }, [id_company]);

  if (loading && !open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm" 
      aria-labelledby="use-term-title"
    >
      <DialogTitle id="use-term-title">Termos de Uso</DialogTitle>

      <DialogContent dividers>
        <div style={{ minHeight: '35vh', maxHeight: '65vh', overflowY: 'auto' }}>
          <Editor
            readOnly
            editorState={useterm}
            toolbar={{ options: [] }}
            wrapperClassName="rdw-wrapper"
            editorClassName="rdw-editor"
            editorStyle={{
              minHeight: '20vh',
              padding: '8px',
              boxSizing: 'border-box',
              width: '100%',
            }}
            onEditorStateChange={setUseTerm}
          />
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
